import { Creator } from '../../models/creator.model';

export const SYSTEM_AUTOTRIGGER_USER: Creator = {
  id: -1,
  name: 'general_system_autotrigger_user_label',
  email: '',
};
